module.exports = __webpack_public_path__ + "static/technology-20c6441a8592ed2818d530354ecb42ba.png";